import React, { useState, useEffect } from 'react';
import { Route, Switch, Redirect } from "react-router-dom";
import { Routes } from "../routes";
import PrivateRoute from "../utils/PrivateRoute";

// pages
import SCT from "./SCT";
import Configuration from "./Configuration";
import Signin from "./Signin";
import NotFoundPage from "./NotFound";
import ForgotPassword from "./ForgotPassword";
// components
import Preloader from "../components/Preloader";
import Header from "../components/Header";

// Loader component for authenticated routes
const RouteWithLoader = ({ component: Component, ...rest }) => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setLoaded(true), 1000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <PrivateRoute {...rest} render={props => (
       <>
         <Preloader show={loaded ? false : true} />
         <Header />
         <Component {...props} />
       </>
    )} />
  );
};

const AppRoutes = () => (
  <Switch>
    {/* Authenticated Routes */}
    <RouteWithLoader exact path={Routes.SCT.path} component={SCT} />
    <RouteWithLoader exact path={Routes.Configuration.path} component={Configuration} />

    {/* Public Routes */}
    <Route exact path={Routes.Signin.path} component={Signin} />
    <Route exact path={Routes.ForgotPassword.path} component={ForgotPassword} />

    {/* Not Found */}
    <Route exact path={Routes.NotFound.path} component={NotFoundPage} />
    <Redirect to={Routes.NotFound.path} />
  </Switch>
);

export default AppRoutes;